import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector     : 'carded-left-sidebar-1-normal-scroll',
    templateUrl  : './left-sidebar-1.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CardedLeftSidebar1NormalScrollComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
